// extracted by mini-css-extract-plugin
module.exports = {"dropDownMenu":"Menu_dropDownMenu__1FtE8"};